// 意大利语
import constant from '../../constants/lang/it';
import newLang from '../newLang/it';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: "Si prega effettuare prima l'accesso",
        404: 'Nessun dato',
        500: 'Il sistema è occupato, riprova più tardi',
        504: 'Tempo scaduto per la richiesta',
        ERR_NETWORK: 'Eccezione di rete',
        ERR_NETWORK_UPLOAD: "Caricamento non riuscito, prova con un'altra rete",
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Indicatore luminoso',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Disco',
        'feedback-create': 'Feedback',
        'feedback-supplement': 'Feedback aggiuntivi',
        'feedback-detail': 'Dettagli del feedback',
        'feedback-result': 'Feedback',
        guide: 'Centro assistenza',
        'guide-restScreen': 'Come impostare il veicolo Istruzioni',
        'guide-overview': 'Panoramica delle funzioni',
        'guide-account': 'Informazioni sul conto',
        'guide-vehicle': 'Informazioni sul veicolo',
        'guide-meterSetting': 'Come impostare il cruscotto',
        'guide-vehicleSetting': 'Come impostare il veicolo',
        'guide-findNavigation': 'Come navigare per trovare il veicolo',
        'guide-vehicleNnavigation': 'Come utilizzare la navigazione',
        'guide-cyclingRecord': 'Informazioni sulla cronologia di marcia',
        'guide-vehicleExperience': `Come eseguire un'autoispezione del veicolo`,
        'guide-useSetting': `Come configurare le impostazioni generali dell'APP`,
        'guide-notice': 'Come visualizzare e impostare la notifica dei messaggi',
        'guide-about': 'A proposito di APP',
        help: 'Aiuto & feedback',
        'help-detail': 'Dettagli della domanda',
        'myCar-unbinding': 'Applicare il disincaglio',
        'myCar-unbinding-result': 'Applicare il disincaglio',
      },
    },
    form: {
      cancel: 'Annulla',
      confirm: 'Conferma',
      submit: 'Invia',
      search: 'Cerca',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Protocollo`,
      text1: '1.	Servizi telematici',
      text2:
        'CFMOTO Powersports, Inc. (di seguito denominato " CFMOTO " ) fornisce servizi telematici per veicoli al cliente che ha acquistato il veicolo CFMOTO (di seguito denominato "Cliente" ). Per questi servizi, CFMOTO utilizza i dati registrati dal Veicolo sul Veicolo e sul suo comportamento di guida nel periodo di tempo pertinente. In dettaglio si tratta dei seguenti dati:',
      text3: `Dati sul comportamento di guida dell'utente : inclusi accelerazione, decelerazione, velocità, curvatura, ultimo tempo di guida e ultimo chilometraggio di guida .`,
      text4:
        'Dati sullo stato del veicolo: si riferiscono allo stato in tempo reale del veicolo, inclusa la modalità di guida, il carburante residuo, il consumo di carburante istantaneo, il chilometraggio, la marcia in tempo reale del veicolo, la velocità del motore, la pressione dei pneumatici, la temperatura dei pneumatici, i dati sulla tensione di attivazione della batteria , temperatura del liquido di raffreddamento, stato del blocco elettronico, versione del software del dispositivo intelligente, potenza del segnale dei dispositivi intelligenti, impostazione corrente del cruscotto.',
      text5:
        'Dati di allarme del veicolo: dati di allarme da inviare se determinati dati superano un valore preimpostato, come temperatura del motore, velocità eccessiva, tempo di guida eccessivo, temperatura del liquido di raffreddamento elevata, movimento anomalo del veicolo, pressione dei pneumatici anomala, vibrazioni, ribaltamento, collisione , ecc . .',
      text6: 'Informazioni Guasto Veicolo: si riferisce ai codici di guasto segnalati da ciascuna parte interna del Veicolo.',
      text7: 'Dati sulla posizione del veicolo: si riferisce alla posizione geografica specifica del veicolo.',
      text8: `1.1.	Fornitura _ il Cliente con servizi relativi al veicolo attraverso l' APP CFMOTO RIDE .`,
      text9: `1.1.1.	APP CFMOTO RIDE (compresa la visualizzazione della posizione del veicolo, l'impostazione delle informazioni e delle funzioni del veicolo, il controllo remoto dello stato del veicolo, ecc.).`,
      text10: '1.1.2.	Pianificazione del percorso durante la navigazione, compreso il calcolo della distanza tra i veicoli e la navigazione a piedi allo scopo di trovare un veicolo .',
      text11: '1.2.	Invio delle necessarie notifiche al Cliente in base alle condizioni del veicolo.',
      text12:
        '1.2.1.	CFMOTO invierà le notifiche al Cliente sulla manutenzione del veicolo (ad es. in base alla distanza totale percorsa dal Cliente, al momento in cui il Cliente acquista il veicolo, ai requisiti di tempo o distanza di guida per la manutenzione del veicolo) .',
      text13: `1.2.2.	Sulla base dei dati del veicolo , CFMOTO invierà al Cliente segnalazioni di situazioni anomale; compresa l'analisi dei dati da parte dell'OEM (a seconda del modello) per fornire assistenza al cliente e ottimizzazione del follow-up del veicolo .`,
      text14: `1.3.	Supporto nell'analisi della causa del sinistro qualora il Cliente segnali un grave sinistro del Veicolo.`,
      text15: `1.3.1.	In caso di incidente grave del Veicolo, ad esempio quando il Veicolo si ribalta o si ribalta su un fianco durante la guida, CFMOTO supporterà il Cliente su richiesta nel chiarire se l'incidente sia dovuto a un difetto del Veicolo o ad altre circostanze. La richiesta deve essere presentata a CFMOTO dal Cliente tramite il distributore/partner di vendita locale indicato nel Contratto di Vendita del Veicolo.`,
      text16: `1.3.2.	Nella misura in cui i dati disponibili lo consentano, CFMOTO valuterà i dati in relazione alla causa dell'incidente e fornirà al Cliente un rapporto corrispondente.`,
      text17: '1.4.	Assistenza al Cliente per il recupero del Veicolo dopo lo smarrimento del Veicolo .',
      text18: `1.4.1.	In caso di smarrimento del Veicolo, CFMOTO fornirà al Cliente i dati sulla posizione del Veicolo e altri dati utili sullo stato del Veicolo (come la posizione dell'ultima attivazione, lo stato attuale del veicolo, ecc.) su richiesta e se disponibili.`,
      text19: '1.4.2.	La richiesta deve essere presentata a CFMOTO dal Cliente tramite il distributore/partner di vendita locale indicato nel Contratto di Vendita del Veicolo.',
      text20: '1.5.	Segnalazione problemi post vendita .',
      text21: '1.5.1.	CFMOTO raccoglie da remoto le notifiche dei codici di errore inviate dal Veicolo in caso di malfunzionamento dei suoi componenti e fornisce le relative informazioni su richiesta del Cliente direttamente al Cliente.',
      text22: '1.5.2.	La richiesta deve essere presentata a CFMOTO dal Cliente tramite il distributore/partner di vendita locale indicato nel Contratto di Vendita del Veicolo.',
      text23: '2.	Restrizioni ed Esclusioni di Servizio',
      text24: `2.1.	Si precisa espressamente che modifiche strutturali o di altra natura tecnica al Veicolo possono limitare o addirittura rendere impossibile l'erogazione dei servizi, in quanto i servizi dipendono dal corretto conferimento dei dati del veicolo.`,
      text25: `2.2.	Laddove tali servizi non possono essere forniti a causa dell'esecuzione di dati o reti di telecomunicazione di terze parti , è esclusa qualsiasi responsabilità di CFMOTO.`,
      text26: '3.	Riservatezza',
      text27: `CFMOTO rispetterà le normative sulla protezione dei dati applicabili durante il trattamento dei dati personali in relazione al veicolo CFMOTO . I termini dell'informativa sulla privacy di C FMOTO sono definiti in questa APP CFMOTO RIDE . Come integrazione all'informativa sulla privacy , la presente informativa è conforme all'informativa sulla privacy . E il Cliente può fare riferimento all'informativa sulla privacy per alcuni contenuti relativi al trattamento dei dati non coperti da questa informativa.`,
      text28: '4.	Assistenza clienti',
      text29:
        '4.1.	Il Cliente può sentirsi libero di inviare domande, commenti o dubbi relativi alla privacy a CFMOTORIDEAPP@cfmotousa.com o scrivere a: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, MN 55447. Il Cliente può anche chiamare Relazioni con i clienti CFMOTO al numero (888) 823-6686. ',
      text30: '5.	Revisioni _',
      text31: '5.1.	CFMOTO si riserva il diritto di modificare questo avviso in qualsiasi momento, ma pubblicheremo le revisioni su CFMOTO RIDE App e/o fornire un avviso prima di farlo, se del caso.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: `Le nuove impostazioni avranno effetto entro 1-3 minuti dall'accensione del veicolo, assicurarsi che il veicolo sia in una buona posizione del segnale`,
      setSuccess: 'Impostato con successo',
      sure: 'Sicura',
      confirm: 'Conferma',
      cancel: 'Annulla',
      cContent: 'Le impostazioni non sono state ancora salvate, vuoi salvarle?',
      save: 'Salva le impostazioni',
      introduce1: 'Vicino alle istruzioni di sblocco automatico',
      introduce2: 'istruzioni per lo spegnimento automatico',
      introduce3: 'Istruzioni di riattivazione automatica',
      introduce4: 'Spegnimento ritardato delle luci',
      content1: {
        msg1: `Dopo aver attivato la funzione, il telefono cellulare attiva il Bluetooth e l'app continua a funzionare. Quando ci si avvicina al veicolo da lontano a vicino, il veicolo può essere sbloccato automaticamente e acceso.`,
        msg2: 'Se non è normalmente sbloccato e acceso, premere il pulsante di accensione del veicolo per sbloccare e accendere',
        msg3: 'Lo sblocco automatico di prossimità verrà attivato solo una volta prima che il bluetooth venga disconnesso',
      },
      content2: {
        msg1: `Dopo l'accensione della funzione, il veicolo si spegne automaticamente dopo 5 secondi dopo lo spegnimento delle tre condizioni del veicolo, la velocità del veicolo è 0 e il tempio è caduto`,
        msg2: 'Avviando il veicolo durante il periodo di spegnimento automatico, la velocità del veicolo non è 0, o il tempio è messo via annullerà lo spegnimento automatico',
      },
      content3: {
        msg1: `Dopo l'attivazione della funzione, quando il veicolo è spento, il telefono cellulare accende il Bluetooth e l'APP continua a funzionare o porta la chiave fisica. Quando ci si avvicina al veicolo da lontano a vicino, le luci del veicolo lampeggeranno per accogliere gli ospiti`,
        msg2: 'Al fine di evitare che i frequenti trigger causino la perdita di potenza del veicolo, dopo che la funzione di benvenuto è stata attivata due volte entro 30 secondi, non riprenderà fino a 30 minuti dopo',
      },
      content4: {
        msg1: 'Dopo aver attivato la funzione, le luci lontane e anabbaglianti si accenderanno automaticamente per 10 secondi dopo lo spegnimento del veicolo',
      },
    },
    feedback: {
      label: {
        type: 'Tipo di feedback (scelta singola)',
        content: 'Descrizione del problema',
        fileList: "Caricare un'immagine",
        fileList2: '(Massimo 4 immagini / 1 video)',
        feedbackCreate: 'Clicca per il feedback',
        feedbackSupplement: 'Feedback aggiuntivi',
        backHome: 'Torna alla home page',
        vehicle: 'veicolo associato',
        selectVehicle: 'selezionare il veicolo',
      },
      placeholder: {
        'content.bug':
          "Si prega di descrivere dettagliatamente l'ora in cui si è verificato il problema, la versione dell'APP, il modello di telefono cellulare, il percorso operativo e la descrizione del problema per aiutarci a individuare e risolvere rapidamente il problema!",
        'content.suggest': 'Benvenuti a dare suggerimenti preziosi, prenderemo seriamente in considerazione le vostre idee.',
        'content.vehicle': 'Descrivere quando è successo, come è successo e il problema.',
        'content.other': 'Descrivere quando è successo, come è successo e il problema.',
        'content.supplement': 'Aggiungi una descrizione del problema',
        vehicle: 'Seleziona un veicolo',
      },
      rules: {
        'type.required': 'Seleziona un tipo di feedback',
        'content.required': 'Inserire una descrizione del problema',
        'fileList.uploading': 'Caricamento in corso, attendere',
        'fileList.maxSize': 'Il file caricato è troppo grande',
        'fileList.overType': 'Formato non supportato',
        'fileList.maxCount': 'Il numero di upload supera il limite',
        'fileList.acceptImageVideo': 'Non è possibile selezionare il video quando si selezionano le immagini',
        'vehicle.required': 'Seleziona un veicolo',
      },
      message: {
        empty: 'Al momento non ci sono registrazioni di feedback.',
        finish: 'Risposta',
        loading: 'Caricamento',
        uploadFailed: 'Caricamento fallito',
        tip: 'Per proteggere la sicurezza del proprio account, si prega di non inserire qui informazioni personali sensibili, come password di account, ecc.',
        feedbackSuccess: 'Feedback ricevuto',
        'submit.error': 'Feedback fallito',
        'submit.success': 'Feedback ricevuto',
      },
    },
    guide: {
      label: { giveFeedback: 'Irrisolto, voglio dare un feedback' },
    },
    help: {
      label: {
        history: 'Cerca record',
        cancel: 'Annulla',
        yes: 'Sì',
        no: 'No',
        unresolved: 'Non riesci ancora a risolvere? Clic',
        submitFeedback: 'Invia feedback',
      },
      placeholder: {
        search: 'Cerca',
        'content.required': 'Si prega inserire la parola chiave',
      },
      message: {
        empty: 'Nessun contenuto correlato',
        empty2: 'Suggerisci di cambiare le parole chiave o',
        finish: 'Risposta',
        historyDelete: 'Eliminare tutti i record di ricerca?',
        isHelpful: 'Aiuta?',
      },
    },
    unbinding: {
      label: {
        vin: 'VIN',
        realName: 'Nome e cognome',
        email: 'Indirizzo e-mail',
        phone: 'Numero di telefono',
        areaCode: 'Prefisso internazionale',
        identity: 'Identificazione',
        drivingLicense: 'Certificato di registrazione del veicolo.',
        backHome: 'Torna alla home page',
        areaCodeTitle: 'Prefisso internazionale',
        latterTitle: 'Avviso',
        agree: 'Approvate',
        disagree: "Non sono d'accordo",
        agreeCheckLabel: 'È stato letto e concordato',
        agreeCheckTitle: 'Istruzioni per la richiesta di svincolamento del veicolo',
      },
      placeholder: {
        vin: 'Si prega di inserire il VIN',
        realName: 'Inserisci il tuo vero nome',
        email: 'Inserisci il tuo indirizzo email',
        phone: 'Per favore immetti il ​​tuo numero di telefono',
        identity: "Pagina principale della carta d'identità, patente di guida o passaporto contenente informazioni personali di identificazione.",
        drivingLicense: 'Pagina principale del certificato di registrazione del veicolo con nome del proprietario e numero di identificazione del veicolo (VIN).',
      },
      rules: {
        'agree.required': 'Leggere e accettare',
        'vin.required': 'Si prega di inserire il VIN',
        'vin.pattern': 'VIN errato, per favore verifica.',
        'realName.required': 'Inserisci il tuo vero nome',
        'email.required': 'Inserisci il tuo indirizzo email',
        'email.pattern': "Il formato dell'indirizzo email è errato, controlla per favore.",
        'phone.required': 'Per favore immetti il ​​tuo numero di telefono',
        'phone.pattern': 'Errore nel formato del numero di telefono, controllare',
        'fileList.maxCount': 'Il numero di upload supera il limite',
        'fileList.uploading': 'Caricamento in corso, attendere',
      },
      message: {
        imgUploadFailed: 'Caricamento immagine non riuscito',
        securityMessage: "Le informazioni sopra riportate sono utilizzate esclusivamente per la verifica dell'identità; CFMOTO tutela le tue informazioni.",
        resultMessage: "Verificheremo i materiali dell'applicazione il prima possibile, si prega di prestare attenzione alla barra delle notifiche o al centro messaggi dell'APP in tempo.",
        loading: 'Caricamento',
      },
    },
  },
};
